const ORGANISATION_ID_PATTERN = /^((?:[a-z0-9]+_)?)organisation_[A-Za-z0-9]+$/
const VALIDATION_SUBMISSION_ID_PATTERN = /^((?:[a-z0-9]+_)?)validationsubmission_[A-Za-z0-9]+$/

export const isValidInitialVsId = (initialVsId: string, organisationId: string): boolean => {
  const vsEnvironment = VALIDATION_SUBMISSION_ID_PATTERN.exec(initialVsId)?.[1]
  const organisationEnvironment = ORGANISATION_ID_PATTERN.exec(organisationId)?.[1]

  return vsEnvironment !== undefined && vsEnvironment === organisationEnvironment
}
